"use client";

import { useState } from "react";
import { FAQ_ITEMS } from "./faqData";
const FaqAccordion = () => {
  const [openIndex, setOpenIndex] = useState<number>(0);
  return <div className='mx-auto w-full max-w-[1141px] px-5 md:px-0' data-sentry-component="FaqAccordion" data-sentry-source-file="FaqAccordion.tsx">
      {FAQ_ITEMS.map((item, index) => {
      const isOpen = openIndex === index;
      return <div key={item.question} className={index === 0 ? "bg-white" : "border-t-[0.596px] border-solid border-[#53535d] bg-white md:border-t"}>
            <button type='button' aria-expanded={isOpen} onClick={() => setOpenIndex(isOpen ? -1 : index)} className='flex w-full items-center gap-[14px] py-3 text-left md:py-4'>
              <span aria-hidden='true' className='flex w-5 shrink-0 items-center justify-center text-[20px] font-semibold leading-none text-accent-500 md:w-8 md:text-[34px]'>
                {isOpen ? "-" : "+"}
              </span>
              <span className='text-[17px] font-semibold leading-[1.3] text-primary-500 md:text-[25px] md:leading-[1.5]'>
                {item.question}
              </span>
            </button>

            {isOpen && <div className='mb-3 rounded-b-[8px] bg-[rgba(244,242,233,0.5)] px-6 py-5 md:mb-4 md:px-9'>
                <div className='text-[15px] leading-[1.5] text-brand-dark md:text-[22px] [&_p:last-child]:mb-0 [&_p]:mb-3'>
                  {item.answer}
                </div>
              </div>}
          </div>;
    })}
    </div>;
};
export default FaqAccordion;